import React from "react";
import Dashboard from "../../../component/atom/Icon/SVG/Dashboard";
import {
  DefaultRouteParam,
  RouteConfig,
} from "../../../config/router/router.config";

export type DashboardRouteParam = DefaultRouteParam;

export const homeDashboardRoute: RouteConfig = {
  name: "Dashboard",
  Component: React.lazy(() => import("./HomeDashboard.view")),
  path: "/dashboard",
  isPrivate: true,

  options: {
    icon: <Dashboard />,
    label: "Dashboard",
    testID: "MenuDashboard",
  },
};
